import { trpc } from '@/shared/api/trpc';

// Create a product (catalog + category/subcategory + title). Invalidates the
// list / filterCounts on settle; callers navigate to the returned product's
// edit page on success.
export const useCreateProduct = () => {
  const utils = trpc.useUtils();
  return trpc.products.create.useMutation({
    onSettled: () => {
      utils.products.list.invalidate();
      utils.products.filterCounts.invalidate();
    },
  });
};
